
















import {Vue, Prop, Component} from 'vue-property-decorator';
import * as $ from 'jquery';
import ToggleSwitch from '@/components/UiComponents/ToggleSwitch.vue';
@Component({
    components: {ToggleSwitch}
})
export default class LetterFilter extends Vue {

    mounted(){
        $('#filter-dropdown').dropdown({action: 'nothing'});
    }
}
